import { jsx } from 'react/jsx-runtime';

const SvgMiscBoltAltFill = (props) => jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props, { children: jsx("path", { fill: "#2D2E2E", d: "M9 23.66 20.54 9.91H15V.16L3.46 13.91H9v9.75Z" }) }));

export { SvgMiscBoltAltFill as default };
//# sourceMappingURL=MiscBoltAltFill.es.js.map
